import { render } from "./compact.vue?vue&type=template&id=807f34e4"
import script from "./compact.vue?vue&type=script&lang=js"
export * from "./compact.vue?vue&type=script&lang=js"

import "./compact.vue?vue&type=style&index=0&id=807f34e4&lang=css"
script.render = render

export default script